export type Agent = {
  __typename: 'Agent';
  id: string;
  name: string;
  personality?: string | null;
  userId: string;
  tone: Tone | undefined;
  createdAt: string;
  updatedAt: string;
};

export enum Tone {
  CASUAL = 'CASUAL',
  PROFESSIONAL = 'PROFESSIONAL',
  FRIENDLY = 'FRIENDLY',
  ENCOURAGING = 'ENCOURAGING',
  MOTIVATIONAL = 'MOTIVATIONAL',
  NEUTRAL = 'NEUTRAL'
}
